<template>
  <div>
    <div class="itemsStyle">
      <BaseText
        @input="emitSectionNameData($event)"
        v-model="questions.questionText"
        placeholder="متن را اینجا وارد نمائید"
        :maxlength="200000"
        required
        :showError="checkQuestionValidate && !questions.questionText.length"
        errortext="وارد کردن این فیلد الزامی است"
      />
      <div class="title">گزینه ها</div>
      <div v-for="(ans, index) in questions.answers" :key="index" class="itemsStyle">
        <div style="display: flex; gap: 20px">
          <b-form-radio v-if="questions.questionType === 0" v-model="ans.isCorrect" value="true" style="margin-top: 7px" @change="onCheckSingleSelection($event, index)">
            جواب درست
          </b-form-radio>

          <b-form-checkbox v-else v-model="ans.isCorrect" style="margin-top: 7px" @change="checkRadioInput($event, index)"> جواب درست </b-form-checkbox>

          <i v-if="questions.answers.length > 2" @click="removeRadioField(index)" class="removeIcon fa-regular fa-circle-xmark" />

          <BaseText
            v-model="ans.title"
            required
            :maxlength="200000"
            style="width: 100%"
            :placeholder="placeHolderGenerator(index)"
            :showError="ans.checkAnswerValidate && !ans.title.length"
            errortext="وارد کردن این فیلد الزامی است"
          />
        </div>
      </div>

      <div class="d-flex justify-content-end align-items-center">
        <div @click="addRadioOption" class="addItemButton">+ اضافه کردن گزینه</div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseText from '@/components/common/form/formModules/BaseText.vue'
export default {
  components: {
    BaseText,
  },
  data() {
    return {
      inputData: {
        index: null,
        payload: null,
      },
      answer: true,
      status: undefined,
    }
  },
  props: {
    checkQuestionValidate: { type: Boolean, required: true },
    questions: {
      type: Object,
      default: () => [
        {
          questionText: '.',
          questionType: 1,
          order: 0,
          answers: [
            {
              title: '',
              isCorrect: true,
              order: 0,
            },
            {
              title: '',
              isCorrect: false,
              order: 1,
            },
          ],
        },
      ],
    },
  },
  methods: {
    placeHolderGenerator(payload) {
      return `جواب ${payload + 1}`
    },
    checkRadioInput($event, index) {
      this.$emit('checkRadioInput', $event, index)
    },
    onCheckSingleSelection($event, index) {
      this.questions.answers.forEach((item, idx) => {
        if (idx === index) item.isCorrect = true
        else item.isCorrect = false
      })

      this.$emit('checkRadioInput', $event, index)
    },
    emitSectionNameData(payload) {
      this.$emit('sectionNameChange', payload)
    },
    addRadioOption() {
      this.$emit('addRadioOptionClick')
    },
    removeRadioField(index) {
      this.$emit('removeRadioFieldIndex', index)
    },
  },
  computed: {},
}
</script>

<style scoped lang="scss">
.title {
  color: #495057;
  font-size: 13px;
  margin-bottom: 10px;
  margin-top: 20px;
}
.itemsStyle {
  margin-bottom: 20px;
  position: relative;
}
.itemsStyle:last-child {
  margin-bottom: 0px;
}
.removeIcon {
  color: #ff4861;
  font-size: 19px;
  cursor: pointer;
}
.addItemButton {
  background: #ffffff;
  border: 1px solid #556ee6;
  border-radius: 4px;
  color: #556ee6;
  padding: 8px 18px;
  cursor: pointer;
  font-size: 13px;
}
::v-deep .custom-control {
  width: 200px;
  display: flex;
}
::v-deep .custom-control .custom-control-label {
  margin-right: 5px !important;
}

::v-deep .custom-control .custom-control-input {
  border-color: #d7d7d7;
  width: 18px;
  height: 18px;
}

::v-deep .custom-control .custom-control-input:checked {
  background-color: #34c38f;
  border-color: inherit;
  color: white;
}

::v-deep .custom-control .custom-control-input:un-checked {
  background-color: #fff;
  border-color: inherit;
  color: white;
}
</style>
